import {
  addDays, differenceInCalendarDays, endOfMonth, endOfQuarter, endOfWeek, endOfYear, format, parseISO,
  startOfMonth, startOfQuarter, startOfWeek, startOfYear, subDays, subMonths, subQuarters, subWeeks, subYears,
} from 'date-fns';

const f = (d) => format(d, 'yyyy-MM-dd');
const wk = { weekStartsOn: 1 };
const fyStart = (d) => new Date(d.getMonth() >= 3 ? d.getFullYear() : d.getFullYear() - 1, 3, 1);

const PREV = {
  today: (n) => [subDays(n, 1), subDays(n, 1), 'Yesterday'],
  yesterday: (n) => [subDays(n, 2), subDays(n, 2), 'Day Before'],
  this_week: (n) => [startOfWeek(subWeeks(n, 1), wk), endOfWeek(subWeeks(n, 1), wk), 'Last Week'],
  last_week: (n) => [startOfWeek(subWeeks(n, 2), wk), endOfWeek(subWeeks(n, 2), wk), 'Week Before'],
  this_month: (n) => [startOfMonth(subMonths(n, 1)), endOfMonth(subMonths(n, 1)), 'Last Month'],
  last_month: (n) => [startOfMonth(subMonths(n, 2)), endOfMonth(subMonths(n, 2)), 'Month Before'],
  this_quarter: (n) => [startOfQuarter(subQuarters(n, 1)), endOfQuarter(subQuarters(n, 1)), 'Last Quarter'],
  last_quarter: (n) => [startOfQuarter(subQuarters(n, 2)), endOfQuarter(subQuarters(n, 2)), 'Quarter Before'],
  this_year: (n) => [startOfYear(subYears(n, 1)), endOfYear(subYears(n, 1)), 'Last Year'],
  last_year: (n) => [startOfYear(subYears(n, 2)), endOfYear(subYears(n, 2)), 'Year Before'],
  this_fy: (n) => [subYears(fyStart(n), 1), subDays(fyStart(n), 1), 'Last Financial Year'],
  last_fy: (n) => [subYears(fyStart(n), 2), subDays(subYears(fyStart(n), 1), 1), 'FY Before'],
};

export const comparisonRanges = (from, to, preset, presetLabel) => {
  const n = new Date();
  if (!from && !to) {
    return { cur: [f(startOfMonth(n)), f(n)], prev: [f(startOfMonth(subMonths(n, 1))), f(endOfMonth(subMonths(n, 1)))], curLabel: 'This Month', prevLabel: 'Last Month' };
  }
  if (!from || !to) return null;
  if (PREV[preset]) {
    const [a, b, label] = PREV[preset](n);
    return { cur: [from, to], prev: [f(a), f(b)], curLabel: presetLabel || 'Selected', prevLabel: label };
  }
  const len = differenceInCalendarDays(parseISO(to), parseISO(from)) + 1;
  const pf = subDays(parseISO(from), len);
  return { cur: [from, to], prev: [f(pf), f(addDays(pf, len - 1))], curLabel: presetLabel || 'Selected Period', prevLabel: 'Previous Period' };
};
